import { computed } from 'vue';
import { useRoute } from 'vue-router';
/**
 * get current layout name from router meta
 * */
export function useLayout() {
  const layout = computed(() => useRoute().meta.layout);
  return { layout };
}
